import type { ReactNode } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import type { SnackbarKey, SnackbarProviderProps } from "notistack";
import { useSnackbar, SnackbarProvider } from "notistack";

function SnackbarCloseButton(snackbarKey: SnackbarKey): ReactNode {
  const { closeSnackbar } = useSnackbar();
  return (
    <IconButton
      onClick={() => {
        closeSnackbar(snackbarKey);
      }}>
      <CloseIcon sx={{ color: "white" }} />
    </IconButton>
  );
}

export function SDEAppsSnackbarProvider({
  children,
  ...props
}: Readonly<SnackbarProviderProps>): ReactNode {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      action={SnackbarCloseButton}
      preventDuplicate
      {...props}>
      {children}
    </SnackbarProvider>
  );
}
